import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import axios from 'axios';
import './shareChatView.css'; // Import the enhanced CSS
import { FaUser, FaRobot } from 'react-icons/fa'; // Optional icons
import BubbleNetwork from "../components/logo/BubbleNetwork";
import BubbleNetworkStatic from "../components/logo/BubbleNetworkStatic";
import MarkdownRenderer from '../utils/MarkdownRenderer';
import '../utils/MarkDownRenderer.css'; // Import markdown CSS explicitly

const SharedChatView = () => {
    const { token } = useParams();
    const location = useLocation();
    const [sharedChat, setSharedChat] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const apiBaseUrl = process.env.REACT_APP_SERVER_URL;

    const searchParams = new URLSearchParams(location.search);
    const singleMessageId = searchParams.get('messageId');

    useEffect(() => {
        const fetchSharedChat = async () => {
            try {
                const response = await axios.get(`${apiBaseUrl}/api/share/${token}`);
                setSharedChat(response.data);
                setLoading(false);
            } catch (err) {
                setError('Failed to load shared chat.');
                setLoading(false);
                console.error('Error fetching shared chat:', err);
            }
        };
        fetchSharedChat();
    }, [token, apiBaseUrl]);

    if (loading) {
        return <div className="loading-container">Loading shared chat...</div>;
    }

    if (error) {
        return <div className="error-container">Error: {error}</div>;
    }

    if (!sharedChat) {
        return <div className="not-found-container">Shared chat not found.</div>;
    }

    const allMessages = sharedChat.messages || [];

    // When a single message link is opened, show the full Q&A pair
    // instead of only the AI answer. We use the selected message
    // plus its adjacent user/AI partner based on sender and index.
    let visibleMessages;
    if (singleMessageId) {
        const idx = allMessages.findIndex(
            (msg) => String(msg._id) === String(singleMessageId)
        );

        if (idx === -1) {
            // Fallback: if not found, show nothing or full list
            visibleMessages = [];
        } else {
            const selected = allMessages[idx];
            const prev = allMessages[idx - 1];
            const next = allMessages[idx + 1];

            if (selected.sender === 'AI' && prev && prev.sender === 'user') {
                // Typical case: share AI answer → show question (user) + answer (AI)
                visibleMessages = [prev, selected];
            } else if (selected.sender === 'user' && next && next.sender === 'AI') {
                // If we ever share from the question bubble, include its answer
                visibleMessages = [selected, next];
            } else {
                // Fallback: just the selected message
                visibleMessages = [selected];
            }
        }
    } else {
        visibleMessages = allMessages;
    }

    return (
        <div className="shared-chat-view-wow">
            <div className="shared-chat-header-container">
                <BubbleNetwork/>
                <h1 className="empty-chat-title">Medhas AI</h1>
            </div>
            <h2 className="wow-title">Shared Conversation</h2>
            {/* <div className="auth-buttons">
          <button onClick={() => window.location.href = 'https://medhas.ai/login'} className="login-button">Log In</button>
          <button onClick={() => window.location.href = 'https://medhas.ai/signup'} className="signup-button">Join Now</button>
        </div> */}
        
            <div className="messages-wow">
                {visibleMessages.map((msg, index) => (
                    <div key={index} className={`message-wow-container ${msg.sender === 'user' ? 'user' : 'AI'}`}>
                        <div className="message-wow-content">
                            {/* Optional: Sender Icons */}
                            {msg.sender === 'user' && <FaUser className="sender-icon user-icon" />}
                            {msg.sender === 'AI' && <FaRobot className="sender-icon bot-icon" />}
                            <div className="message-wow-text">
                                <MarkdownRenderer text={msg.text} />
                            </div>
                            <span className="message-wow-timestamp">
                                {new Date(msg.timestamp).toLocaleString()}
                                {msg.edited && <span className="edited-wow">(Edited {new Date(msg.editedAt).toLocaleString()})</span>}
                            </span>
                        </div>
                    </div>
                ))}
            </div>
            {/* <p className="created-at-wow">Created At: {new Date(sharedChat.createdAt).toLocaleString()}</p> */}
            {/* Optional: Link back to dashboard */}
            <div className="auth-button">
          <button onClick={() => window.location.href = 'https://medhas.ai/login'} className="login-button">Log In</button>
          {/* <button onClick={() => window.location.href = 'https://medhas.ai/signup'} className="signup-button">Join Now</button> */}
        </div>
        </div>
    );
};

export default SharedChatView;